import * as trackingKeys from 'actions/trackingKeys'

import { actionTypes } from './actionTypes'

export function menuServiceDataReceived() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.MENU_SERVICE_DATA_RECEIVED,
      trackingData: {
        actionType: trackingKeys.receiveMenuServiceData,
      },
    })
  }
}
